import { render, staticRenderFns } from "./SubmitInput.vue?vue&type=template&id=1d1cce52"
import script from "./SubmitInput.vue?vue&type=script&lang=js"
export * from "./SubmitInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports